import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import bemify from 'bemify-js';

import { StaticImage } from '@zapier/common-components';

import Link from 'app/common/components/Link';

import './NextSteps.scss';
import Confetti from '../components/Confetti';
import Paragraph from '../components/Paragraph';
import StepTitle from '../components/StepTitle';

const bem = bemify('next-steps');

const NextStepsTutorial = () => {
  const intl = useIntl();

  return (
    <div className={bem()}>
      <div className={bem('__hero')}>
        <StaticImage
          alt="next-steps-emoji"
          className={bem('__image')}
          src="https://cdn.zapier.com/zapier/images/developer-guide/next-steps-emoji.svg"
          title={intl.formatMessage({
            id: 'captions-next-steps-emoji-title',
            defaultMessage: 'Smiling face',
          })}
        />
        <Confetti />
        <StepTitle>
          <FormattedMessage
            defaultMessage="Congrats! You set up your environment."
            id="headings-environment-setup-congratulations"
          />
        </StepTitle>
      </div>
      <Paragraph>
        <FormattedMessage
          defaultMessage="Good news! You've just set up your Zapier development environment, created an app, run your first automated test, and deployed your app to the Zapier platform! Whew! Take a break, then come back and let's keep going."
          id="descriptions-environment-setup-success-summary"
        />
      </Paragraph>
      <Paragraph>
        <FormattedMessage
          defaultMessage="Our <component0>developer docs</component0> will help you actually build some functionality into your app and integrate your API with the Zapier platform."
          id="descriptions-developer-docs-next-steps-link"
          values={{
            component0: chunks => (
              <Link
                href="https://github.com/zapier/zapier-platform/blob/main/packages/cli/README.md"
                target="_blank"
              >
                {chunks}
              </Link>
            ),
          }}
        />
      </Paragraph>
    </div>
  );
};

export default NextStepsTutorial;
